import { cents } from "./notePricing";

export function noteAmountAllowed(source, total, reducing = false) {
  return Boolean(
    source &&
      source.eligible !== false &&
      Number.isFinite(total) &&
      cents(total) > 0 &&
      (!reducing || cents(total) <= cents(source.allowance))
  );
}

export function confirmationValid(confirmation, source, requested, today) {
  const { amount, date, reference, consent, difference, mode } = confirmation;
  if (
    !source ||
    !consent ||
    !reference.trim() ||
    !/^\d{1,9}(?:\.\d{1,2})?$/.test(String(amount)) ||
    cents(amount) <= 0 ||
    !/^\d{4}-\d{2}-\d{2}$/.test(date) ||
    date > today
  )
    return false;
  const parsed = new Date(`${date}T00:00:00Z`);
  if (
    !Number.isFinite(parsed.getTime()) ||
    parsed.toISOString().slice(0, 10) !== date
  )
    return false;
  if (cents(amount) !== cents(requested) && !difference) return false;
  return (
    mode !== "post" ||
    (source.eligible !== false &&
      cents(amount) <= cents(source.balance) &&
      cents(amount) <= cents(source.allowance))
  );
}
